import { Component } from '@angular/core';

@Component({
  selector: 'offsets-payment',
  templateUrl: './offsets-payment.component.html',
  styleUrls: ['./offsets-payment.component.css']
})
export class OffsetsPaymentComponent {

}
